import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { consumeRedirectToast } from "../utils/responseHandler";

const ALLOWED_TOAST_TYPES = new Set(["success", "error", "info", "warn"]);

const normalizeToastType = (type) => (type === "warning" ? "warn" : type);

const ToastProvider = ({ children }) => {
  useEffect(() => {
    const redirectToastData = consumeRedirectToast();
    if (!redirectToastData) return;
    const redirectToast =
      typeof redirectToastData === "object"
        ? {
            message: redirectToastData.message,
            type: redirectToastData.type || "error",
            toastId: redirectToastData.toastId || "session-expired",
          }
        : {
            message: redirectToastData,
            type: "error",
            toastId: "session-expired",
          };
    if (!redirectToast.message) return;
    const normalizedToastType = normalizeToastType(redirectToast.type);
    const toastType = ALLOWED_TOAST_TYPES.has(normalizedToastType)
      ? normalizedToastType
      : "error";
    const toastMethod = toast[toastType];
    toastMethod(redirectToast.message, { toastId: redirectToast.toastId });
  }, []);

  return (
    <>
      {children}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ToastProvider;
